import * as React from "react";
import { GraphConfigurationContext, GraphConfigurationProvider, } from "./ConfigurationHandler/index";
import { GraphDataContext, GraphDataProvider } from "./DataHandler/index";
import { GraphsTabs } from "./GraphsTabs";
import { getInitialConfig } from "./models/plotConfig";
import { PregrafosConfigurationProvider } from "./PreGrafosConfig/PregrafosConfigurationContext";
import { PlotTools } from "./Tools/PlotTools";
import { FolderType } from "./interfaces/config";
import { evaluatePregrafosConfig, getAllPregrafosTabs } from "./utils";
export default React.memo(function ResponsivePlot(props) {
    const data = {
        data: props.data.data,
        objects: props.data.objects ? props.data.objects : [],
    };
    const iniConfig = getInitialConfig(props.config.vars, props.data.data, props.colorPalette);
    const isValid = props.pltAvailable
        ? evaluatePregrafosConfig(props.plt)
        : false;
    const usedConfig = isValid ? props.plt : iniConfig;
    return (React.createElement(PregrafosConfigurationProvider, { initialValue: props.config.vars },
        React.createElement(GraphConfigurationProvider, { initialData: usedConfig },
            React.createElement(GraphDataProvider, { initialData: data },
                React.createElement(GraphDataContext.Consumer, null, ({ data: grafosData }) => (React.createElement(GraphConfigurationContext.Consumer, null, ({ grafosConfig }) => {
                    const tabsConfig = getAllPregrafosTabs(grafosConfig);
                    return (React.createElement("div", { style: {
                            display: "flex",
                            flexDirection: "column",
                            height: "100%",
                            gap: "12px",
                        } },
                        !props.hideTitle && (React.createElement("div", { className: "program-header", key: "header" },
                            React.createElement("div", { className: "program-label" },
                                React.createElement("label", null, props.title)),
                            React.createElement("div", { className: "program-button_container" },
                                React.createElement("div", { className: "program-button", key: "button" },
                                    React.createElement(PlotTools, { config: grafosConfig, iniConfig: iniConfig, savePlot: props.savePlot }))))),
                        React.createElement("div", { style: {
                                width: `100%`,
                                flex: "1 1 auto",
                                position: "relative",
                            } },
                            React.createElement(GraphsTabs, { data: grafosData, tabs: tabsConfig, hideTitle: props.hideTitle, folderType: FolderType.Defined, baseFileName: props.baseFileName }))));
                })))))));
});
//# sourceMappingURL=ResponsivePlot.js.map